module.exports={select:"Markera",selected:"Markerad"};